import { ApiClient } from '../client/ApiClient';
import { GiftCardBalanceCheckRequest, GiftCardBalanceCheckResponse } from './types';
import { ApiResponse } from '../types';
import { waitForAndGenerateRecaptchaToken } from '../utils/recaptcha/waitForAndGenerateRecaptchaToken';
import { generateRecaptchaHeaders } from '../utils/recaptcha/generateRecaptchaHeaders';

const ORDER_SERVICE_RECAPTCHA_ACTION = 'orderServiceApi';

export class OrderServiceClient extends ApiClient {
  private readonly _orderServiceBaseUrl: string;

  constructor({ orderServiceBaseUrl }: { orderServiceBaseUrl: string }) {
    super();
    this._orderServiceBaseUrl = orderServiceBaseUrl;
  }

  balanceCheck = async (body: GiftCardBalanceCheckRequest): Promise<ApiResponse<GiftCardBalanceCheckResponse>> => {
    const { token, message } = await waitForAndGenerateRecaptchaToken(ORDER_SERVICE_RECAPTCHA_ACTION);

    if (!token) {
      return { statusCode: 500, error: new Error(message) };
    }

    const { data, statusCode, error } = await this._fetch<GiftCardBalanceCheckResponse>({
      path: `${this._orderServiceBaseUrl}/GiftCardBalanceCheck`,
      method: 'POST',
      body,
      headers: generateRecaptchaHeaders(token, ORDER_SERVICE_RECAPTCHA_ACTION),
    });

    return { data: data ?? JSON.parse(error?.message ?? ''), statusCode, error };
  };
}
